import React, { useEffect, useRef, useState } from 'react';
import Config from '../server.json';
import PdfViewer from './PdfViewer'; 

const HomePage = () => {
  const [offices, setOffices] = useState([]);
  const [selected, setSelected] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(false);
   const [status, setStatus] = useState('');
  const [pdfType, setPdfType] = useState('External'); 

  const emailRef = useRef();

  useEffect(() => {
    const savedOffice = localStorage.getItem('selectedOffice');
    if (savedOffice) {
      setSelected(savedOffice);
    }
  }, []);

  useEffect(() => {
    fetch(Config.API_URL)
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {
        // Sort alphabetically by officedescription
        const sorted = data.sort((a, b) =>
          a.officedescription.localeCompare(b.officedescription)
        );
        setOffices(sorted);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching office list:', err);
        setError('Failed to load offices');
        setLoading(false);
      });
  }, []);
  

  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => {
        setStatus('');
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [status]);


  

  const handleSelectChange = (e) => {
    const newValue = e.target.value;
    setSelected(newValue);
    localStorage.setItem('selectedOffice', newValue);
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const sendEmail = async (type) => {
    const email = emailRef.current.value.trim();
    const selectedOffice = offices.find((office) => office.officeid === selected);
    if (!email || !selected || !validateEmail(email)) {
      setStatus('Please enter a valid email address.');
      return;
    }

    setSending(true);
     setStatus('');

    try {
      const response = await fetch(Config.SEND_EMAIL_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          officeID: selected,
          officeDescription: selectedOffice?.officedescription || '',
          type, // "External" or "Internal"
        }),
      });

      const result = await response.json();
      if (result.success) {
        setStatus(`✅ ${type} PDF sent to ${email}`);
      } else {
        setStatus(`❌ Error: ${result.error || 'Unknown error'}`);
      }
    } catch (err) {
      console.error(err);
      setStatus('❌ Failed to send. Check your network or try again later.');
    }

    setSending(false);
    emailRef.current.value = '';
  };

  const backgroundImage = "url('/bgwhite.jpg')";

  const openFullscreen = () => {
    const elem = document.documentElement; 

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    } else {
      alert('Fullscreen API is not supported on this browser.');
    }
  };




  return (
    <div
      className="w-screen h-screen bg-center bg-no-repeat bg-cover overflow-hidden flex items-center justify-center"
      style={{ backgroundImage }}
    >

      

      {!selected && (
        <div className="bg-white bg-opacity-90 p-6 rounded-lg shadow-md">
          <label htmlFor="officeSelect" className="block mb-2 font-semibold text-gray-700">
            Select Office:
          </label>

          {loading && <p className="mb-2 text-gray-500">Loading offices...</p>}
          {error && <p className="mb-2 text-red-600">{error}</p>}

          <select
  id="officeSelect"
  className="p-2 border border-gray-300 rounded w-72"
  value={selected}
  onChange={handleSelectChange}
  disabled={loading || !!error}
>
  <option value="">-- Select an Office --</option>
  {offices
    .filter((office) => !["11", "12", "22", "23", "45", "48", "49", "50", "51"].includes(office.officeid))
    .map((office) => (
      <option key={office.officeid} value={office.officeid}>
        {office.officedescription}
      </option>
    ))}
</select>

        </div>
      )}

      {selected && (
        // <div className="fixed inset-0 bg-white bg-opacity-95 p-10 overflow-auto">
            <div className="fixed inset-0 bg-white bg-opacity-95 p-10 overflow-auto">

{/* Top Office Description Banner */}
<div className="fixed top-0 left-0 bg-white bg-opacity-90 py-2 px-4 shadow z-50">
  <p className="text-lg font-semibold text-gray-800">
     CITIZEN'S CHARTER - {offices.find((office) => office.officeid === selected)?.officedescription} 
  </p>
</div>


    
          <div className="flex flex-col lg:flex-row gap-6 justify-center items-center h-full">
            <div className="flex-1">
            
            <PdfViewer 
  fileUrl={`/${selected}-${pdfType}.pdf`} 
  pdfType={pdfType} 
  setPdfType={setPdfType} 
  selectedOffice={selected}
/>
            
            </div>

            <div className="  bg-white bg-opacity-90 p-4 rounded shadow-md w-full max-w-48">
            <div className="flex flex-col justify-center space-y-2 mt-2 items-center">

<button
  onClick={() => setPdfType('External')}
  style={{
    padding: '8px 16px',
    borderRadius: '8px',
    width: '100%',
    backgroundColor: pdfType === 'External' ? '#1877F2' : '#e5e7eb',
    color: pdfType === 'External' ? '#ffffff' : '#374151',
    border: 'none',
    cursor: 'pointer',
  }}
>
  Show External Service
</button>

<button
  onClick={() => setPdfType('Internal')}
  style={{
    padding: '8px 16px',
    borderRadius: '8px',
    width: '100%',
    backgroundColor: pdfType === 'Internal' ? '#1877F2' : '#e5e7eb',
    color: pdfType === 'Internal' ? '#ffffff' : '#374151',
    border: 'none',
    cursor: 'pointer',
  }}
>
  Show Internal Service
</button>

<button
  onClick={() => {
    setSelected('');
    localStorage.removeItem('selectedOffice');
  }}
  style={{
    padding: '8px 16px',
    borderRadius: '8px',
    width: '100%',
    backgroundColor: '#FFAE34',
    color: '#ffffff',
    border: 'none',
    cursor: 'pointer',
  }}
>
  Change Office
</button>

</div>
            </div>
            
  {/* Email Form */}
  <div className="  bg-white bg-opacity-90 p-4 rounded shadow-md w-full max-w-48">
  <p className="text-xl mb-2 font-semibold text-center">Send PDF Services to Email</p>

                <input
                  ref={emailRef}
                  type="email"
                  placeholder="Enter your email address here"
                  // className="border px-3 py-2 rounded w-full mb-2"
                  className="border px-3 py-2 rounded w-full mb-2 overflow-x-auto whitespace-nowrap"
                  style={{ textOverflow: 'ellipsis' }}
                  disabled={sending}
                />

                <div className="flex gap-2 justify-center">

<button
  onClick={() => sendEmail(pdfType)}
  disabled={sending}
  style={{
    padding: '8px 16px',
    borderRadius: '8px',
    width: '100%',
    backgroundColor: '#2E7D32',
    color: '#ffffff',
    opacity: sending ? 0.7 : 1,
    border: 'none',
    cursor: sending ? 'not-allowed' : 'pointer',
  }}
>
  {sending ? `Sending ${pdfType}...` : 'Send'}
</button>


                </div>

                {status && <p className="text-sm mt-2 text-center">{status}</p>}

              </div>
              
              <div className="flex flex-col items-center justify-center px-2 text-center">
  <p className="text-sm font-semibold">
    <span
      onClick={() => {
        setSelected('');
        localStorage.removeItem('selectedOffice');
      }}
      className="cursor-pointer select-none"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          setSelected('');
          localStorage.removeItem('selectedOffice');
        }
      }}
      aria-label="Back to office selection"
    >
      CLIENT SATISFACTION MEASUREMENT FORM
    </span>
    <br />
    <span className="text-sm font-normal">
      (FORM NG SUKATAN NG KASIYAHAN NG KLIYENTE)
    </span>
  </p>

  <br />
  <p className="text-base font-semibold">SCAN ME</p>
  <img
    src={`/${selected} - QR.jpg`}
    alt="QR Code"
    className="w-20 h-20 object-contain border mt-2"
  />
</div>

          </div>
        </div>
      )}

 <button
        onClick={openFullscreen}
        className="absolute right-0 top-0 w-48 h-auto m-4 z-50 bg-transparent border-none p-0 focus:outline-none"
        aria-label="Enter Fullscreen"
      >
        <img
          src="/tayona.png"
          alt="Tayo Na"
          className="w-48 h-auto cursor-pointer"
          draggable={false}
        />
      </button>

    </div>
  );
};

export default HomePage;
